<template id="switch-button">
  <div class="switch-button-control col col-lg-2">
    <div class="input-group">
      <label
        @click="changeContent"
        :style="disabled && { color: 'rgb(113,113,113)' }"
      >
        Agente CCEE
      </label>
      <div>
        <div
          class="switch-button"
          :class="{ enabled: model.content }"
          @click="changeContent"
          :style="{ '--color': '#FFFFFF' }"
        >
          <div class="button"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    modelProp: Object,
  },
  data() {
    return {
      model: {
        name: "agenteCcee",
        content: false,
      },
    };
  },
  methods: {
    changeContent() {
      !this.disabled && (this.model.content = !this.model.content);
      !this.disabled && this.$emit("handleSwitchChange");
    },
  },
  watch: {
    modelProp: {
      deep: true,
      handler() {
        this.model.content = this.modelProp[this.model.name];
      },
    },
    "model.content": {
      deep: true,
      handler() {
        this.modelProp[this.model.name] = this.model.content;
        if (this.model.content) {
          this.$emit("clearRepresentanteFields");
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/colors.scss";
.switch-button-control {
  .input-group {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .switch-button {
    margin-top: 10px !important;
    background: $primary--gray;
    $switch-button-height: 1em;
    $switch-button-color: transparent;
    $switch-button-border-thickness: 2px;
    $switch-transition: all 0.3s ease-in-out;
    $switch-is-rounded: true;

    height: $switch-button-height;
    width: calc(#{$switch-button-height} * 2);
    border: $switch-button-border-thickness solid $switch-button-color;
    box-shadow: inset 0px 0px $switch-button-border-thickness 0px
      rgba(0, 0, 0, 0.33);
    border-radius: if($switch-is-rounded, $switch-button-height, 0);

    transition: $switch-transition;

    $button-side-length: calc(
      #{$switch-button-height} - (2 * #{$switch-button-border-thickness})
    );

    cursor: pointer;

    .button {
      height: $button-side-length;
      width: $button-side-length;
      border: $switch-button-border-thickness solid $switch-button-color;
      border-radius: if($switch-is-rounded, $button-side-length, 0);
      background: white;
      box-shadow: 0.5px 0.5px 2px $black-overlay;

      transition: $switch-transition;
    }

    &.enabled {
      background-color: $primary--orange;
      box-shadow: none;

      .button {
        background: white;
        transform: translateX(
          calc(#{$button-side-length} + (2 *#{$switch-button-border-thickness}))
        );
      }
    }
  }
}
</style>
